import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RecordingState {
  isRecording: boolean;
  enableTranscription: boolean;
  startTranscriptionRecording: boolean;
}

const initialState: RecordingState = {
  isRecording: false,
  enableTranscription: false,
  startTranscriptionRecording: false,
};

export const recordingSlice = createSlice({
  name: 'recording',
  initialState,
  reducers: {
    setRecording: (
      state,
      action: PayloadAction<RecordingState['isRecording']>
    ) => {
      state.isRecording = action.payload;
    },
    setEnableTranscription: (state, action: PayloadAction<boolean>) => {
      state.enableTranscription = action.payload;
    },
    setStartTranscriptionRecording: (state, action: PayloadAction<boolean>) => {
      state.startTranscriptionRecording = action.payload;
    },
  },
});

export const {
  setRecording,
  setEnableTranscription,
  setStartTranscriptionRecording,
} = recordingSlice.actions;

export default recordingSlice.reducer;
